import {FieldConfig} from '../../dynamic-field/field.config';

export class TimeFieldConfig extends FieldConfig<string> {
    showSpinners?: boolean;
    showSeconds?: boolean;
    minHours?: string;
    maxHours?: string;
    showClearButton?: boolean;
    showClearButtonIfReadonly?: boolean;
    useTextInput?: boolean;
}
